import axios from 'axios';

export default class UuidService {
  /**
   * @type {Set}
   */
  static queryIds = new Set();

  /**
   * @type {boolean}
   */
  static isLoading = false;

  static add(id) {
    UuidService.queryIds.add(id);
  }

  static remove(id) {
    if (UuidService.queryIds.has(id)) {
      UuidService.queryIds.delete(id);
    }
  }

  static kill(queryIds = new Set(), batchSize = 100) {
    if (UuidService.isLoading || UuidService.queryIds.size === 0) {
      return;
    }
    UuidService.isLoading = true;
    const setIntersection = (a, b) => new Set([...a].filter((x) => b.has(x)));
    const ids = [
      ...(queryIds.size > 0
        ? setIntersection(UuidService.queryIds, queryIds)
        : UuidService.queryIds),
    ];

    try {
      // Break into batches
      const batches = [];
      for (let i = 0; i < ids.length; i += batchSize) {
        batches.push(ids.slice(i, i + batchSize));
      }

      // Fire all batches using sendBeacon instead of axios
      // navigator.sendBeacon is a non-blocking call - helps to send kill requests even on page unload.
      batches.forEach((batch) => {
        const body = JSON.stringify({ query_ids: batch.join(',') });
        // eslint-disable-next-line tap/no-raw-text-js
        const blob = new Blob([body], { type: 'application/json' });
        // eslint-disable-next-line tap/no-raw-text-js
        const ok = navigator.sendBeacon(`${window.location.origin}/server/api/core/kill`, blob);

        if (!ok) {
          // Fallback to axios for guaranteed delivery
          axios
            .post(`${window.location.origin}/server/api/core/kill`, body, {
              headers: { 'Content-Type': 'application/json' },
            })
            .catch((err) => Logger.log('Axios kill fallback also failed', err));
        }
      });
      ids.forEach((id) => UuidService.queryIds.delete(id));
    } catch (e) {
      // do nothing
    } finally {
      UuidService.isLoading = false;
    }
  }
}
